import styled, { keyframes } from 'styled-components';

import { device } from 'styles/device';

interface FormFirstSectionWrapperProps {
  increaseMinHeight?: boolean;
}

export const appearFromLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const Container = styled.main<FormFirstSectionWrapperProps>`
  display: flex;
  margin: auto;
  flex: 1;

  @media ${device.sm} {
    max-width: 540px;
  }

  @media ${device.md} {
    max-width: 720px;
  }

  @media ${device.lg} {
    max-width: 960px;
  }

  @media ${device.xl} {
    max-width: 1230px;
  }
`;

export const FormContainer = styled(Container)`
  animation: ${appearFromLeft} 1s;
  display: flex;
  flex: 1;
`;
